(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class CollectionTabsComponent extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.setup());
    }

    setup() {
      const body = this.querySelector('.collection-tabs__body');
      if (!body) return;

      const buttons = body.querySelectorAll('.collection-tabs__btn');
      const panels = body.querySelectorAll('.collection-tabs__panel');
      if (!buttons.length) return;

      /* Mobile: wrap buttons in a horizontal scroll container */
      this.#setupMobileScroll(body, buttons);

      /* Activate first tab + panel, then enable JS override */
      buttons[0].classList.add('active');
      buttons[0].setAttribute('aria-selected', 'true');
      if (panels[0]) panels[0].classList.add('active');
      body.classList.add('tabs-ready');

      /* Lazy-load: detach non-first panels into templates */
      panels.forEach((panel, i) => {
        if (i > 0) {
          const tpl = document.createElement('template');
          while (panel.firstChild) tpl.content.appendChild(panel.firstChild);
          panel._lazyTemplate = tpl;
        }
      });

      body.onclick = (e) => {
        const btn = e.target.closest('.collection-tabs__btn');
        if (btn) this.#switchTab(btn, body);
      };
    }

    #setupMobileScroll(body, buttons) {
      const wrapper = document.createElement('div');
      wrapper.className = 'collection-tabs__scroll-wrapper';
      buttons.forEach(btn => {
        const clone = btn.cloneNode(true);
        wrapper.appendChild(clone);
      });
      body.prepend(wrapper);

      /* Sync clicks from scroll wrapper to original buttons */
      wrapper.onclick = (e) => {
        const cloneBtn = e.target.closest('.collection-tabs__btn');
        if (!cloneBtn) return;
        e.stopPropagation(); /* Prevent body.onclick from firing a second switchTab */
        const tabId = cloneBtn.dataset.tabId;

        /* Update active state on cloned buttons */
        wrapper.querySelectorAll('.collection-tabs__btn').forEach(b => b.classList.remove('active'));
        cloneBtn.classList.add('active');

        /* Scroll active button into view within wrapper only */
        const scrollLeft = cloneBtn.offsetLeft - (wrapper.offsetWidth / 2) + (cloneBtn.offsetWidth / 2);
        wrapper.scrollTo({ left: scrollLeft, behavior: 'smooth' });

        /* Trigger switch on original button */
        const originalBtn = body.querySelector(`:scope > .collection-tabs__btn[data-tab-id="${tabId}"]`);
        if (originalBtn) this.#switchTab(originalBtn, body);
      };

      /* Also sync active state when original buttons change */
      const observer = new MutationObserver(() => {
        const activeOriginal = body.querySelector(':scope > .collection-tabs__btn.active');
        if (activeOriginal) {
          const activeId = activeOriginal.dataset.tabId;
          wrapper.querySelectorAll('.collection-tabs__btn').forEach(b => {
            b.classList.toggle('active', b.dataset.tabId === activeId);
          });
        }
      });
      buttons.forEach(btn => observer.observe(btn, { attributes: true, attributeFilter: ['class'] }));

      /* Center buttons if they don't overflow */
      requestAnimationFrame(() => {
        if (wrapper.scrollWidth <= wrapper.clientWidth) {
          wrapper.style.justifyContent = 'center';
        }
      });
    }

    #cleanupTransition(body) {
      body.style.transition = '';
      body.style.minHeight = '';
      body.style.overflow = '';
      clearTimeout(body._transitionTimer);
    }

    #switchTab(activeBtn, body) {
      const targetId = activeBtn.dataset.tabId;

      /* Cancel any in-progress transition */
      this.#cleanupTransition(body);

      /* Lock current height to prevent layout shift */
      const oldHeight = body.offsetHeight;
      body.style.minHeight = oldHeight + 'px';
      body.style.overflow = 'hidden';

      body.querySelectorAll('.collection-tabs__btn').forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      body.querySelectorAll('.collection-tabs__panel').forEach(p => p.classList.remove('active'));

      activeBtn.classList.add('active');
      activeBtn.setAttribute('aria-selected', 'true');

      const panel = body.querySelector(`.collection-tabs__panel[data-tab-id="${targetId}"]`);
      if (!panel) {
        this.#cleanupTransition(body);
        return;
      }

      /* Restore lazy content if needed */
      if (panel._lazyTemplate) {
        panel.appendChild(panel._lazyTemplate.content);
        panel._lazyTemplate = null;
      }

      panel.classList.add('active');

      /* Smooth transition to new panel height */
      requestAnimationFrame(() => {
        const newHeight = body.scrollHeight;
        if (newHeight !== oldHeight) {
          body.style.transition = 'min-height 0.3s ease';
          body.style.minHeight = newHeight + 'px';
          const cleanup = () => this.#cleanupTransition(body);
          body.addEventListener('transitionend', cleanup, { once: true });
          body._transitionTimer = setTimeout(cleanup, 350);
        } else {
          this.#cleanupTransition(body);
        }
      });
    }
  }

  customElements.define('collection-tabs-component', CollectionTabsComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('ul.ul_none.tab-coll').forEach((ul) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'tab-coll-wrapper';
      ul.parentNode.insertBefore(wrapper, ul);

      const btnPrev = document.createElement('button');
      btnPrev.className = 'tab-coll-btn tab-coll-btn--prev';
      btnPrev.setAttribute('aria-label', 'Previous');
      btnPrev.innerHTML = '&#8249;';

      const btnNext = document.createElement('button');
      btnNext.className = 'tab-coll-btn tab-coll-btn--next';
      btnNext.setAttribute('aria-label', 'Next');
      btnNext.innerHTML = '&#8250;';

      wrapper.appendChild(btnPrev);
      wrapper.appendChild(ul);
      wrapper.appendChild(btnNext);

      const scrollAmount = 180;

      function updateButtons() {
        btnPrev.disabled = ul.scrollLeft <= 0;
        btnNext.disabled = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 1;
      }

      btnPrev.addEventListener('click', () => {
        ul.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      btnNext.addEventListener('click', () => {
        ul.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      ul.addEventListener('scroll', updateButtons);
      updateButtons();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
